import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  massExecutionIssuesUpdate,
  massValidationIssuesUpadate,
} from "../../../services/IssueManagementService";
import { massUpdateRuleResearchIssuesNew } from "../../../services/ResearchIssuesService";
import { useToast } from "../../../services/utils";
import { issueStatus } from "../../../services/constants";
import { useAuth } from "../../../contexts/AuthContext";
import { useClassificationContext } from "../../../contexts/ClassificationContext";
import useFetchReasonsByClassification from "../../../hooks/useFetchReasonsByClassification";
interface IncidentUserandStatusProps {
  userDialogData: any;
  setUserDialogData: any;
  allUsersList: any;
  setDetailViewDataRows: any;
  setSelectedIds: any;
  //  issueFrom?: "comparison" | "validation" | "research";
  issueFrom?: "execution" | "validation" | "ruleResearch" | "genericResearch";
}

const IncidentUserandStatusDialog = ({
  userDialogData,
  setUserDialogData,
  allUsersList,
  setDetailViewDataRows,
  setSelectedIds,
  issueFrom = "execution",
}: IncidentUserandStatusProps) => {
  const { userInfo } = useAuth();
  const { showToast } = useToast();
  const [charCount, setCharCount] = useState(0);
  const [errors, setErrors] = useState({
    exceedCount: false,
  });

  const [formData, setFormData] = useState<any>({
    status: "New",
    assigned_user: "",
    comment: "",
    issue_classification_id: null,
    issue_reason_id: null,
  });

  // Classifications from global context (fetched once for the whole app)
  const { allClassifications } = useClassificationContext();

  const activeClassifications = (allClassifications || []).filter(
    (c: any) => c.is_active
  );

  // Fetch reasons only for the currently selected classification (optimized)
  const [fetchedReasons] = useFetchReasonsByClassification(
    formData?.issue_classification_id
  );

  const filteredReasons = fetchedReasons.filter((r: any) => r.is_active);

  const handleCloseDialog = () => {
    setFormData({
      status: "New",
      assigned_user: "",
      comment: "",
      issue_classification_id: null,
      issue_reason_id: null,
    });
    setUserDialogData((prev: any) => ({
      ...prev,
      status: false,
      dialogName: "",
    }));
    setErrors((prev: any) => ({
      ...prev,
      exceedCount: false,
    }));
    setCharCount(0);
  };

  const handleClose = (reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
  };
  const handleStatusUpdate = () => {
    const issuesUpdate: any = {
      assigned_user: formData?.assigned_user || "",
      assigned_by: userInfo?.username || "",
      status: formData?.status || "",
      comment: formData?.comment || "",
      issue_classification_id: formData?.issue_classification_id || null,
      issue_reason_id: formData?.issue_reason_id || null,
    };

    const payload = {
      issue_ids: userDialogData?.selectedIds,
      issues_update: issuesUpdate,
    };
    const cleanedPayload = Object.fromEntries(
      Object.entries(payload).filter(
        ([_key, value]) => value !== null && value !== ""
      )
    );

    if (issueFrom === "execution") {
      massExecutionIssuesUpdate(cleanedPayload)
        .then((response) => {
          if (response) {
            setDetailViewDataRows((prevState: any) =>
              prevState.map((item: any) => {
                if (userDialogData?.selectedIds?.includes(item.rowId)) {
                  return {
                    ...item,
                    current_status: formData?.status,
                    assigned_user: formData?.assigned_user,
                    comment: formData?.comment,
                    issue_classification_id: formData?.issue_classification_id,
                    issue_reason_id: formData?.issue_reason_id,
                  };
                }
                return item;
              })
            );
            setSelectedIds([]);
            showToast("Issue updated successfully!", "success");
          }
        })
        .catch((error) => {
          showToast(`Cannot update issue`, "error");
        });
    } else if (issueFrom === "validation") {
      massValidationIssuesUpadate(payload)
        .then((response) => {
          if (response) {
            setDetailViewDataRows((prevState: any) =>
              prevState.map((item: any) => {
                if (userDialogData?.selectedIds?.includes(item.rowId)) {
                  return {
                    ...item,
                    current_status: formData?.status,
                    assigned_user: formData?.assigned_user,
                    comment: formData?.comment,
                    issue_classification_id: formData?.issue_classification_id,
                    issue_reason_id: formData?.issue_reason_id,
                  };
                }
                return item;
              })
            );
            setSelectedIds([]);
            showToast("Issue updated successfully!", "success");
          }
        })
        .catch((error) => {
          showToast(`Cannot update issue`, "error");
        });
    } else if (issueFrom === "ruleResearch") {
      const ruleResearchIssuesUpdate: any = {
        assigned_user: formData?.assigned_user || "",
        assigned_by: userInfo?.username || "",
        status: formData?.status || "",
        comment: formData?.comment || "",
        issue_classification_id: formData?.issue_classification_id || null,
        issue_reason_id: formData?.issue_reason_id || null,
      };
      const ruleResearchPayload = {
        issue_ids: userDialogData?.selectedIds || [],
        issues_update: ruleResearchIssuesUpdate,
      };
      massUpdateRuleResearchIssuesNew(ruleResearchPayload)
        .then((response) => {
          if (response) {
            setDetailViewDataRows((prevState: any) =>
              prevState.map((item: any) => {
                if (userDialogData?.selectedIds?.includes(item.rowId)) {
                  return {
                    ...item,
                    current_status: formData?.status,
                    assigned_user: formData?.assigned_user,
                    comment: formData?.comment,
                    issue_classification_id: formData?.issue_classification_id,
                    issue_reason_id: formData?.issue_reason_id,
                  };
                }
                return item;
              })
            );
            setSelectedIds([]);
            showToast("Rule Research issue updated successfully!", "success");
          }
        })
        .catch((error) => {
          showToast(`Cannot update research issue`, "error");
        });
    } else if (issueFrom === "genericResearch") {
      const genericResearchIssuesUpdate: any = {
        assigned_user: formData?.assigned_user || "",
        assigned_by: userInfo?.username || "",
        status: formData?.status || "",
        comment: formData?.comment || "",
        issue_classification_id: formData?.issue_classification_id || null,
        issue_reason_id: formData?.issue_reason_id || null,
      };
      const genericResearchPayload = {
        issue_ids: userDialogData?.selectedIds || [],
        issues_update: genericResearchIssuesUpdate,
      };
      massUpdateRuleResearchIssuesNew(genericResearchPayload)
        .then((response) => {
          if (response) {
            setDetailViewDataRows((prevState: any) =>
              prevState.map((item: any) => {
                if (userDialogData?.selectedIds?.includes(item.rowId)) {
                  return {
                    ...item,
                    current_status: formData?.status,
                    assigned_user: formData?.assigned_user,
                    comment: formData?.comment,
                    issue_classification_id: formData?.issue_classification_id,
                    issue_reason_id: formData?.issue_reason_id,
                  };
                }
                return item;
              })
            );
            setSelectedIds([]);
            showToast(
              "Generic Research issue updated successfully!",
              "success"
            );
          }
        })
        .catch((error) => {
          showToast(`Cannot update research issue`, "error");
        });
    }
  };

  const handleChangeStatus = (value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      status: value,
    }));
  };
  const handleChangeComment = (event: any) => {
    const newComment = event.target.value;
    const limitedComment =
      newComment.length <= 500 ? newComment : newComment.slice(0, 500);
    setCharCount(limitedComment.length);
    setFormData((prev: any) => ({
      ...prev,
      comment: limitedComment,
    }));
    setErrors((prev: any) => ({
      ...prev,
      exceedCount: limitedComment.length === 500,
    }));
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={userDialogData?.status}
      onClose={(event, reason) => handleClose(reason)}
      className="modal-dialog-1"
    >
      <DialogTitle className="dialog-title">
        <span>{userDialogData?.dialogName}</span>
        <button className="close-icon" onClick={handleCloseDialog}></button>
      </DialogTitle>
      <DialogContent className="dialog-content">
        <Box>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Autocomplete
                sx={{
                  "& .MuiSelect-select": {
                    height: "36px",
                  },
                }}
                className={`form-control-autocomplete`}
                options={issueStatus}
                getOptionLabel={(option) => option}
                onChange={(event, value) => handleChangeStatus(value)}
                value={formData?.status}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Update Status"
                    variant="outlined"
                  />
                )}
                isOptionEqualToValue={(option, value) => option === value}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Autocomplete
                sx={{
                  "& .MuiSelect-select": {
                    height: "36px",
                  },
                }}
                className={`form-control-autocomplete`}
                options={allUsersList}
                getOptionLabel={(option) => {
                  return option?.username || "";
                }}
                value={
                  (allUsersList?.length > 0 &&
                    allUsersList?.find(
                      (user: { username: string | undefined }) =>
                        user.username === formData?.assigned_user
                    )) ||
                  null
                }
                onChange={(_event, value) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    assigned_user: value?.username,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Assign to user"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Autocomplete
                sx={{ "& .MuiSelect-select": { height: "36px" } }}
                className={`form-control-autocomplete`}
                options={activeClassifications}
                getOptionLabel={(option: any) =>
                  option?.issue_classification_name || ""
                }
                value={
                  activeClassifications.find(
                    (c: any) => c.id === formData?.issue_classification_id
                  ) || null
                }
                onChange={(_event, value) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    issue_classification_id: value?.id || null,
                    issue_reason_id: null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Classification"
                    variant="outlined"
                  />
                )}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.id === value.id
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Autocomplete
                sx={{ "& .MuiSelect-select": { height: "36px" } }}
                className={`form-control-autocomplete reason-autocomplete`}
                options={filteredReasons}
                getOptionLabel={(option: any) => option?.reason_name || ""}
                value={
                  filteredReasons.find(
                    (r: any) => r.id === formData?.issue_reason_id
                  ) || null
                }
                onChange={(_event, value) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    issue_reason_id: value?.id || null,
                  }));
                }}
                disabled={!formData?.issue_classification_id}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    className={`${
                      (props as any).className ?? ""
                    } reason-autocomplete-option`}
                    title={option.reason_name}
                  >
                    {option.reason_name}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Reason"
                    variant="outlined"
                    placeholder={
                      !formData?.issue_classification_id
                        ? "Select Classification first"
                        : "Select Reason"
                    }
                  />
                )}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.id === value.id
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="incident-box"
            >
              <Box className="comment-section">
                <Box>
                  <h3>
                    Comments&nbsp;
                    <span
                      className={`normal ${
                        errors?.exceedCount ? "required m-0" : ""
                      }`}
                    >
                      ({charCount}/500)
                    </span>
                  </h3>
                </Box>
                <Box className="comment-box">
                  <TextareaAutosize
                    className={`form-control-1 textarea`}
                    minRows={3}
                    maxRows={6}
                    aria-label="minimum height"
                    placeholder="Add a comment"
                    value={formData?.comment}
                    name={"comment"}
                    onChange={handleChangeComment}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions className="dialog-footer">
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={() => {
            handleCloseDialog();
            handleStatusUpdate();
          }}
          className="btn-orange"
          disabled={
            !(
              formData.status ||
              formData.comment ||
              formData.assigned_user ||
              formData.issue_classification_id ||
              formData.issue_reason_id
            )
          }
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IncidentUserandStatusDialog;
